/**
 * A service that adds .viewport-entered when element enters viewport.
 */
import debounce from 'lodash/debounce';

type TrackedElement = {
  element: Element;
  y: number;
};

var trackedElements: TrackedElement[] = [];

var scrollY = 0;
const updateElementClasses = () => {
  scrollY = window.scrollY;
  const windowHeight = window.innerHeight;
  trackedElements.forEach((el) => {
    const isInViewport = el.y > scrollY && el.y < scrollY + windowHeight;
    if (isInViewport) {
      el.element.classList.add('viewport-entered');
    }
  });
};

const storeElementY = debounce(() => {
  trackedElements = trackedElements.map((el) => {
    el.y = el.element.getBoundingClientRect().top + window.scrollY;
    return el;
  });
});

const initializeEventListeners = () => {
  if (trackedElements.length === 1) {
    window.addEventListener('scroll', updateElementClasses, { passive: true });
    window.addEventListener('resize', storeElementY, { passive: true });
    window.addEventListener('load', storeElementY);
    window.addEventListener('DOMContentLoaded', storeElementY);
  }
  updateElementClasses();
};

export const monitorVisibility = (el: Element) => {
  trackedElements.push({
    element: el,
    y: el.getBoundingClientRect().top + window.scrollY,
  });
  initializeEventListeners();
};

export const monitorVisibilityForQuery = (query: string) =>
  document.querySelectorAll(query).forEach((el) => {
    monitorVisibility(el);
  });
